import './apps/bankrate-cookie'
import './accordions'
import 'js/mortgages/tabs.js'
import 'js/mortgages/modal.js'
import 'js/mortgages/toggle.js'
import 'js/mortgages/cards.js'
